import React from 'react'

import { StyleSheet, View, Keyboard } from 'react-native'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import client from '@sart/client'
import { useContent } from '@sart/content'
import { prettyErrorMessage, testID } from '@sart/utilities'
import { adaptive, colors, typography } from '@sart/styles'

import {
  Description,
  Space,
  Button,
  TextInputExtended,
  KeyboardAvoidingView,
  ReturnFooter
} from '@sart/components'

import AppConfig from '../Configuration'

export default function TransferCaptureNumber(props) {
  const { navigation } = props

  const content = useContent()

  const formik = useFormik({
    initialValues: {
      number: '',
    },
    validationSchema: Yup.object().shape({
      number: Yup.string().trim().required(content.forms.required).test('phone-check', content.gift.validnumber, function(value) {
        if(value) {
          return value.match(/^\d{10}$/)
        } else {
          return true
        }
      }), // content.register_number.validateErrorMessage
    }),
    onSubmit: handleSubmit,
  })

  async function handleSubmit(values, form) {
    Keyboard.dismiss()
    form.setSubmitting(true)

    try {
      //check regex for mobile number before submission
      const test = new RegExp(AppConfig.numberRegex, 'g')
      if(!test.test(values.number)){
        formik.setFieldError('number', content.gift.numberNotValid)
        return
      }
      navigation.navigate('TransferMenu', values)
    } catch (error) {
      const message = prettyErrorMessage(error, 'transfer', content)

      form.setFieldError('number', message)
      form.setSubmitting(false)
    }
  }

  return (
    <View style={styles.container}>
      <Space height={24} />

      <Description style={styles.description}>
        {content.gift.giftInstructions}
      </Description>

      <Space height={24} />

      <TextInputExtended
        label={content.register_number.phoneNumberLabel}
        value={formik.values.number}
        placeholder={content.forms.phoneNumberPlaceholder}
        keyboardType="phone-pad"
        onChangeText={formik.handleChange('number')}
        onBlur={formik.handleBlur('number')}
        error={formik.touched.number && formik.errors.number}
        // footer={content.transfer.transferFooter}
        focusedStyle={styles.activeInput}
        style={styles.textInput}
        onSubmitEditing={formik.handleSubmit}
        selectionColor={colors.common}
        maxLength={10}
        {...testID('TransferRecipientNumber')}
      />

      <Space height={24} />

      <Button
        title={
          formik.isSubmitting
            ? content.register_number.inProgress
            : content.register_number.action
        }
        disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
        onPress={formik.handleSubmit}
        style={styles.buttonStyle}
        disabledStyle={styles.disabledButtonStyle}
        titleStyle={{...typography.extrabold, fontSize: 18, color: colors.white}}
        disabledTitleStyle={{...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45}}
        {...testID('TransferRecipientSubmit')}
      />

    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding
  },
  description: {
    textAlign: 'center',
    ...typography.lightbold
  },
  activeInput: {
    // borderColor: colors.exisOrange,
  },
  textInput: {
    ...typography.demi,
    borderColor: colors.srGreen
  },
  buttonStyle: {
    backgroundColor: colors.srDarkGreen
  },
  disabledButtonStyle: {
    backgroundColor: colors.srDarkGreen + 60,
    borderColor: colors.srGreen,
    borderWidth: 1
  }
})
